// Check and update slider state based on number of slides
function checkSliderItems() {
    const slider = document.querySelector('.pdp_slider .swiper');
    
    if (slider) {
        const slides = slider.querySelectorAll('.swiper-slide');
        const parent = slider.closest('.pdp_slider');
        
        if (slides.length === 1 && parent) {
            parent.classList.add('single-slide');
            // Hide navigation and pagination for single slide
            const nav = parent.querySelectorAll('.swiper-button-prev, .swiper-button-next, .swiper-pagination');
            nav.forEach(el => el.style.display = 'none');
        } else if (parent) {
            parent.classList.remove('single-slide');
            // Show navigation and pagination for multiple slides
            const nav = parent.querySelectorAll('.swiper-button-prev, .swiper-button-next, .swiper-pagination');
            nav.forEach(el => el.style.display = '');
        }
    }
}

// Wait for an element to exist in the DOM before executing callback
function waitForElement(selector, callback, maxAttempts = 50) {
    let attempts = 0;
    
    const checkElement = () => {
        attempts++;
        const element = document.querySelector(selector);
        
        if (element) {
            callback();
        } else if (attempts < maxAttempts) {
            setTimeout(checkElement, 100);
        }
    };
    
    checkElement();
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // Check immediately
    checkSliderItems();
    
    // Set up observer for future changes
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                waitForElement('.pdp_slider .swiper', checkSliderItems);
            }
        });
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Periodically check for changes
    setInterval(checkSliderItems, 1000);
});
